import React from 'react';
import classNames from 'classnames';
import { SIGNUP_URL } from '../modules/utils';

interface CsrfMiddlewareProps {
    value: string;
}
const CsrfMiddleware = ({ value }: CsrfMiddlewareProps) => (
    <div style={{ display: 'none' }}>
        <input type="hidden" name="csrfmiddlewaretoken" value={value} />
    </div>
);

interface SignupFormProps {
    buttonText: string;
    signupGridClasses: string;
    showMktgFormClass?: boolean;
}
class SignupForm extends React.PureComponent<SignupFormProps> {
    render() {
        const { buttonText, signupGridClasses, showMktgFormClass } = this.props;
        return (
            <form
                name="signupForm"
                method="post"
                action={SIGNUP_URL}
                className={classNames({
                    'responsive-form': true,
                    'js-validate-signup': true,
                    'mktg-responsive-form': showMktgFormClass,
                })}
            >
                <input type="hidden" name="submitted" value="1" />
                <input type="hidden" name="forward" value="/create" />
                <div className={signupGridClasses}>
                    <input
                        type="email"
                        name="email"
                        placeholder="Email"
                        className="eds-textinput__input"
                        autoComplete="off"
                    />
                </div>
                <div className={signupGridClasses}>
                    <input
                        type="password"
                        name="passwd1"
                        placeholder="Password"
                        className="eds-textinput__input"
                        autoComplete="off"
                    />
                </div>
                <div className={signupGridClasses}>
                    <input
                        type="submit"
                        className="eds-btn eds-btn--button eds-btn--fill eds-btn--responsive mktg-btn-block"
                        value={buttonText}
                    />
                </div>
                <CsrfMiddleware value={'22dc903453d111e887ad37ed408954e9'} />
                <CsrfMiddleware value={'00b6ed88683011e8a908731a40f5a07f'} />
            </form>
        );
    }
}
export default SignupForm;
